import styled from "@emotion/styled";
import React from "react";
import { MergeWithOverwrite } from "src/common";
import { colors } from "src/theme";

const IconSpan = styled.span((props: { height: number, width: number }) => ({
  display: 'inline-flex',
  height: props.height,
  width: props.width,
}))

export type SlipIconProps = MergeWithOverwrite<React.HtmlHTMLAttributes<HTMLSpanElement>, {
  width?: number,
  height?: number,
  color?: string,
}>;

export const SlipIcon: React.FC<SlipIconProps> = ({ width = 16, height = 16, color = colors.primary, ...props }) => (
  <IconSpan {...props} height={height} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M10.1464 0.146447C10.3417 -0.0488155 10.6583 -0.0488155 10.8536 0.146447L12.8536 2.14645C13.0488 2.34171 13.0488 2.65829 12.8536 2.85355L7.85355 7.85355C7.79867 7.90844 7.73175 7.9498 7.65811 7.97434L4.65811 8.97434C4.47845 9.03423 4.28036 8.98747 4.14645 8.85355C4.01253 8.71964 3.96577 8.52155 4.02566 8.34189L5.02566 5.34189C5.0502 5.26825 5.09156 5.20133 5.14645 5.14645L10.1464 0.146447ZM5.93702 5.77009L5.29057 7.70943L7.22991 7.06298L11.7929 2.5L10.5 1.20711L5.93702 5.77009ZM0 6.5C0 6.22386 0.223858 6 0.5 6H2.5C2.77614 6 3 6.22386 3 6.5C3 6.77614 2.77614 7 2.5 7H1V15H15V7H11.5C11.2239 7 11 6.77614 11 6.5C11 6.22386 11.2239 6 11.5 6H15.5C15.7761 6 16 6.22386 16 6.5V15.5C16 15.7761 15.7761 16 15.5 16H0.5C0.223858 16 0 15.7761 0 15.5V6.5ZM3.5 11C3.22386 11 3 11.2239 3 11.5C3 11.7761 3.22386 12 3.5 12H12.5C12.7761 12 13 11.7761 13 11.5C13 11.2239 12.7761 11 12.5 11H3.5Z" fill={color} />
    </svg>
  </IconSpan>
);
